import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {and, comparison, eq, ge, le} from "rsql-builder";
import {Movimiento} from "../models/movimiento.model";
import {MovimientoListFilter} from "../models/movimiento-list-filter.model";

@Injectable({
  providedIn: 'root'
})
export class MovimientoApiService {

  private baseUrl:string = environment.apiBaseUrl+"/core/portal/profile/balance_movements";

  constructor(
    private httpClient: HttpClient
  ) { }

  getMovimientoList(): Observable<Movimiento[]> {
      return this.httpClient.get<Movimiento[]>(this.baseUrl);
  }


  getMovimiento(id): Observable<Movimiento> {
    return this.httpClient.get<any>(this.baseUrl+`/${id}`);
  }

  createMovimiento(importe: any, userReceiverId: any) {
    let req = {
      userReceiverID:userReceiverId,
      importe:importe
    }
    return this.httpClient.post<any>(this.baseUrl+`/add`,req);
  }

  searchMovimientoList(filter: MovimientoListFilter): Observable<PageableApiResult<Movimiento>> {
    const comps = [];

    if(filter.dateFilter && filter.dateFilter.from) {
      comps.push(comparison("date", ge(filter.dateFilter.from)))
    }
    if(filter.dateFilter && filter.dateFilter.to) {
      comps.push(comparison("date", le(filter.dateFilter.to)))
    }
    if(filter.transactionType) {
      comps.push(comparison("transactionType.id", eq(filter.transactionType)))
    }
    let params = null;
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }
    if (filter.sortByAmount) {
      params = params.append("rsort", "amount").append("rdirection",filter.sortByAmount);
    }
    if (filter.sortByDate) {
      params = params.append("rsort", "date").append("rdirection",filter.sortByDate);
    }
    return this.httpClient.get<PageableApiResult<Movimiento>>(
      this.baseUrl +
      `/${filter.page}/${filter.size}`,
      {params}
    );

  }
}

